/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Change_PasswordInputs */

const vi_user_change_password = /** @type {(inputs: User_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi mật khẩu`)
};

/**

* @param {User_Change_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_change_password = /** @type {((inputs?: User_Change_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Change_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_change_password(inputs)
});